/**
 * Проверка адреса возврата на стороне клиента.
 *
 * Дублирует серверную `safeReturnTo` намеренно и по той же причине, что и копия
 * матрицы прав в `app/session.tsx`: сервер всё равно проверяет значение сам и
 * решает он. Здесь проверка нужна лишь затем, чтобы форма не показывала
 * пользователю адрес, по которому его в итоге не отправят.
 *
 * Без неё параметр `returnTo` превращается в открытый редирект: ссылка
 * `/login?returnTo=https://evil.example` увела бы пользователя на чужой сайт
 * сразу после успешного входа.
 */
export function safeReturnTo(value: string | null | undefined): string {
  if (value === undefined || value === null || !value.startsWith('/')) return '/';
  // `//host` браузер трактует как протокол-относительный абсолютный адрес,
  // `/\host` — тоже, из-за нормализации обратных слэшей.
  if (value.startsWith('//') || value.startsWith('/\\')) return '/';
  // Управляющими символами разрезают заголовки ответа. Проверка по кодам, а не
  // регулярным выражением: литеральный управляющий байт в исходнике невидим.
  for (const character of value) {
    const code = character.codePointAt(0) ?? 0;
    if (code < 0x20 || code === 0x7f) return '/';
  }
  return value;
}
